export default __webpack_public_path__ + "source-sans-pro-v11-latin-600italic-a66d11cd485f7d1fd68d59233a59efcd.bundle.woff";